<template>
  <v-card>
    <v-card-title>
      Pilots
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="pilots" :search="search" dense :loading="loading" loading-text="Loading... Please wait">
      <template v-slot:item.StatusId="{ item }">
        <router-link :to="{ name: 'PilotStatus', params: {id:item.RegId} }">
          <v-chip class="mx-2" :color="item.Color" dark fab small><v-icon>mdi-gesture-tap-button</v-icon></v-chip>
        </router-link>
      </template>
      <template v-slot:item.AntMsg="{ item }">
        <!-- <router-link :to="{ name: 'PilotStatus', params: {id:item.RegId} }"> -->
          <v-chip dark min-width="20">{{ item.AntMsg }}</v-chip>
        <!-- </router-link> -->
      </template>
    </v-data-table>
    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color:Red;">{{error.message}}</li>
    </ul>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      loading: true,
      headers: [
        { text: "Name", value: "Name" },
        { text: "Set status", value: "StatusId" },
        { text: "", value: "AntMsg" }
      ],
      pilots: [],
      errors: []
    };
  },

  created() {
    axios
      // .get("http://jsonplaceholder.typicode.com/posts")
      // .get('http://localhost:3000/pilotlist')
      .get("https://pgapi.azurewebsites.net/dbapi/pilotlist")
      .then(response => {
        // JSON responses are automatically parsed.
        this.pilots = response.data;
        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
      });
  },
  methods: {
    getColor(Status) {
      var color = 'gray'
      switch (Status) {
        case 'START':
          color = 'red'
          break;
        case 'LANDED':
          color = 'orange'
          break;
        case 'EXIT':
          color = 'orange'
          break;
        default:
          color = 'blue'
      }
      return color;
    },
    getStatusIdColor(Status) {
      var color = 'gray'
      switch (Status) {
        case 'START':
          color = 'red'
          break;
        case 'LANDED':
          color = 'orange'
          break;
        case 'EXIT':
          color = 'orange'
          break;
        default:
          color = 'blue'
      }
      return color;
    }
  }
};
</script>
